import { post } from '@tencent/pmd-network';
import type { CommercialGoodsSort, GetGoodsListCondition, GetGoodsListParam, GoodsItem } from './types';
import { GetGoodsListConditionType, CommercialGoodsSortType } from './types';
import SearchHandler from './condition/searchHandler';
import Handler from './condition/handler';
import MatchHandler from './condition/matchHandler';
import RangeHandler from './condition/rangeHandler';

/**
 * 同步物品列表数据
 */
export function syncGoodsList(commercialManager) {
  return new Promise((resolve, reject) => {
    const reqData = {};
    post({
      url: commercialManager.getRequest('/pvpesport.sgamenes.award.award/GetGoodsListFileInfo'),
      reqData,
    })
      .then((response) => {
        if (response.r === 0) {
          let jsonData = {
            data: [],
            recommend: {
              list: [],
            },
          };
          const goodsContent = response.goods_content;
          if (goodsContent) {
            try {
              jsonData = JSON.parse(goodsContent);
            } catch (e) {
              console.log(e);
            }
          }
          const result: {
            goodsList: any[],
            recommendGoodsList: any[],
          } = {
            goodsList: [], // 道具物品列表
            recommendGoodsList: [], // 推荐列表
          };
          result.goodsList = parseGoodsList(jsonData.data);
          result.recommendGoodsList = parseGoodsList(jsonData.recommend?.list);
          verifyData(result);
          console.log('goods jsonData:', jsonData);
          console.log('goods result:', result);
          resolve(result);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
}

// 校验数据
function verifyData(data) {
  // 校验英雄数据
  for (const goods of data.goodsList) {
    verifyHeroData(goods);
  }
}

function verifyHeroData(goods) {
  const categoryHero = 1;
  const jobs = [1, 2, 3, 4, 5, 6];
  if (goods.category === categoryHero) {
    if (!jobs.includes(goods.subCategory)) {
      window.mAegis?.error(`[Commercial.GoodsConfig.Hero]: ${JSON.stringify(goods)}`);
    }
  }
}

function parseGoodsList(list) {
  if (!list) {
    return [];
  }
  const result: any[] = [];
  for (const item of list) {
    result.push(parseGoodsItem(item));
  }
  return result;
}

export function parseGoodsItem(item) {
  const result = {
    id: 0, // 物品id
    name: '', // 物品名称
    pic: '', // 物品图片
    bigPic: '', // 详情页图片
    desc: '', // 物品描述
    price: 0, // 售价
    orgPrice: 0, // 原价
    type: 0, // 类型
    category: 0, // 一级分类
    subCategory: 0, // 二级分类
    thirdCategory: 0, // 三级分类
  };
  if (item) {
    const sPriceInfo = item.sPriceInfo?.sPriceInfo || {};
    result.id = item.iGoodsId || '';
    result.name = item.sGoodsName || '';
    result.pic = item.sGoodsPic || '';
    result.bigPic = item.sGoodsPic2 || '';
    result.desc = item.sGoodsDesc || '';
    // 原始返回单位是分，统一转换成元
    result.price = sPriceInfo.iPrice / 100 || 0;
    result.orgPrice = sPriceInfo.iOrgPrice / 100 || 0;
    result.category = item.iCategoryId || 0;
    result.subCategory = item.iSubCategoryId || 0;
    result.thirdCategory = item.iThirdCategoryId || 0;
  }
  return result;
}

export function getGoodsList(goodsList: GoodsItem[] = [], param: GetGoodsListParam) {
  return new Promise((resolve) => {
    const filteredList = filterGoodsList(goodsList, param);
    resolve(filteredList);
  });
}

export function filterGoodsList(goodsList: GoodsItem[] = [], param: GetGoodsListParam) {
  // 先过滤，后排序
  let conditionList = goodsList;
  if (param?.filterConditions) {
    // eslint-disable-next-line no-unsafe-optional-chaining
    for (const condition of param?.filterConditions) {
      conditionList = doFilterCondition(conditionList, condition);
    }
  }
  let sortList = conditionList;
  if (param?.sort && param.sort.type !== CommercialGoodsSortType.CommercialGoodsSortTypeNone) {
    sortList = doSort(sortList, param.sort);
  }
  return sortList;
}

function doFilterCondition(goodsList: GoodsItem[] = [], condition: GetGoodsListCondition): GoodsItem[] {
  const handler = getConditionHandler(condition);
  return handler.handle(goodsList);
}

function getConditionHandler(condition: GetGoodsListCondition): Handler {
  switch (condition.type) {
    case GetGoodsListConditionType.GetGoodsListConditionTypeSearch:
      return new SearchHandler(condition);
    case GetGoodsListConditionType.GetGoodsListConditionTypeMatch:
      return new MatchHandler(condition);
    case GetGoodsListConditionType.GetGoodsListConditionTypeRange:
      return new RangeHandler(condition);
    default:
      break;
  }
  return new Handler(condition);
}

function doSort(goodsList: GoodsItem[] = [], sort: CommercialGoodsSort): GoodsItem[] {
  return goodsList.sort((left, right) => {
    const leftValue = left[sort.key];
    const rightValue = right[sort.key];
    switch (sort.type) {
      case CommercialGoodsSortType.CommercialGoodsSortTypeDesc:
        return leftValue < rightValue ? 1 : -1;
      case CommercialGoodsSortType.CommercialGoodsSortTypeAsc:
        return leftValue > rightValue ? 1 : -1;
      default:
        break;
    }
    return -1;
  });
}
/**
 * 查询奖品库
 */
export const queryUserResourceBundleList = function (reqData) {
  return new Promise((resolve, reject) => {
    post({
      url: '/pvpesport.sgamenes.award.award/QueryUserResourceBundleList',
      showMsgToast: false,
      reqData,
    })
      .then((response) => {
        const req = {
          assetList: filterRepertoryList(response.asset_list),
          hasRight: response.has_right || false,
          start: response.start,
          total: response.total,
        };
        resolve(req);
      })
      .catch((error) => {
        reject(error);
      });
  });
};
function filterRepertoryList(assetList) {
  if (assetList) {
    return assetList.map(item => ({
      ...item,
      goodsId: item.goods_id,
      remaining: item.remaining || 0,
      total: item.total || 0,
      expireTime: item.expire_time || 0,
      goodsInfo: {
        ...item.goods_info,
        goodsId: item.goods_info.goodsid,
      },
      statusText: getStatusText(item),
      btnDisabled: getDisabled(item),
    }));
  }
  return [];
}
function getStatusText(item) {
  if (item.remaining > 0) {
    const currentTime = Math.floor(Date.now() / 1000);
    const isExpired = item.expire_time < currentTime;
    if (isExpired) {
      return '已过期';
    }

    return '去使用';
  }
  return '已使用';
}
function getDisabled(item) {
  if (item.remaining > 0) {
    const currentTime = Math.floor(Date.now() / 1000);
    const isExpired = item.expire_time < currentTime;
    if (isExpired) {
      return true;
    }

    return false;
  }
  return true;
}
